import { render, staticRenderFns } from "./AccountReset.vue?vue&type=template&id=58d731fe&scoped=true"
import script from "./AccountReset.vue?vue&type=script&lang=js"
export * from "./AccountReset.vue?vue&type=script&lang=js"
import style0 from "./AccountReset.vue?vue&type=style&index=0&id=58d731fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d731fe",
  null
  
)

export default component.exports